// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import './themes/base.css'

// log error to sentry
import * as Sentry from '@sentry/browser';
import { Vue as VueIntegration } from '@sentry/integrations';

import Vue from 'vue'
import Vuex from 'vuex'
import VueRouter from 'vue-router'
import VueOnsen from 'vue-onsenui'
import helpers from './helpers'
import store from './store/index'
import routes from './config/routes'
import App from './App'

Vue.config.productionTip = false
Vue.prototype.$helpers = helpers;

Vue.use(VueOnsen)
Vue.use(VueRouter)
Vue.use(Vuex)

Sentry.init({
  dsn: 'https://fbd6c9a7e1ee48218a27bcdb17973074@o408972.ingest.sentry.io/4504891038564352',
  integrations: [new VueIntegration({
    Vue,
    attachProps: true,
    logErrors: true,
  })],
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 0.1,
});

/* eslint-disable no-new */
new Vue({
    el: '#app',
    store: new Vuex.Store(store),
    router: new VueRouter(routes),
    template: '<App/>',
    components: { App },
    beforeMount() {
        const html = document.documentElement;
        if (this.$ons.platform.isIPhoneX()) {
            html.setAttribute('onsflag-iphonex-portrait', '');
            html.setAttribute('onsflag-iphonex-landscape', '');
        }
        // this.$ons.mockStatusBar();
        if (this.$ons.platform.isAndroid()) {
            StatusBar.backgroundColorByHexString("#FEA61D"); // set different status bar color for Android
        }
    },
    beforeCreate() {
        this.$ons.enableAutoStatusBarFill();
        this.$ons.disableAutoStyling();
    },
})



// WEBPACK FOOTER //
// ./src/main.js